import SingleChannelView from './SingleChannelView';

export default SingleChannelView;
